import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  questionIndicator: 'Question',
  close: 'Finish later',
});
